import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { RequestNewLog } from '../../../api/log-requests';
import { RequestDeleteManufacturer, RequestGetManufacturers } from '../../../api/manufacturer-requests';
import DataTable from '../../../components/system/DataTable';
import DebugButton from '../../../components/system/DebugButton';
import Loading from '../../../components/system/loading';
import { useAuth } from '../../../context/auth';
import { ENotificationType, useNotifications } from '../../../context/notifications';
import { IBike } from '../../../interface/bike';
import { ELogType, ESeverity } from '../../../interface/log';
import { IManufacturer } from '../../../interface/manufacturer';
import AdminManufacturer from './Admin.Manufacturer';


const AdminManufacturersPge = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [things, setThings] = useState<IManufacturer[]>();
    let match = useRouteMatch();
    const { addNotification } = useNotifications()!;
    const { auth } = useAuth()!;


    useEffect(() => {
        window.addEventListener('unload', logOnUnload)
        return () => {
            window.removeEventListener('unload', logOnUnload)
            logOnUnload()
        }
    }, [])
    //log unload page?
    const logOnUnload = async () => {
        return RequestNewLog(undefined, {
            type: ELogType.reactUse,
            requestId: '',
            sessionId: '',
            userId: '',
            payload: '',
            severity: ESeverity.Trivial,
            text: 'react stores onunload'
        });
    }
    // eslint-disable-next-line
    {/*<!-- OPTIONAL 1 -->*/ }

    {/*<!-- OPTIONAL END -->*/ }



   
    const mounted = useRef(false);
    useEffect(() => {
        try {
            if (mounted.current === false) {
                mounted.current = true
                // eslint-disable-next-line
                {/*<!-- OPTIONAL 1 -->*/ }
                RequestGetManufacturers(addNotification).then(users => {
                    console.log(users)
                    setThings(users);
                    setLoading(false);
                })
                {/*<!-- OPTIONAL END -->*/ }
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Manufacturers - useEffect', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }

    }, [loading, addNotification]);

    const onDelete = (value: IManufacturer) => {
        try {

            const conf = window.confirm("Delete?");
            if (conf) {
                setLoading(true);
                RequestDeleteManufacturer(addNotification, value).then(res => {
                    //  console.log(res);
                    let thingsD: IManufacturer[] = [];
                    if (things) {
                        thingsD = [...things];
                    }
                    const index = thingsD.findIndex(thing => thing._id === value._id);
                    thingsD.splice(index, 1);

                    setThings(thingsD);
                    setLoading(false);
                    addNotification && addNotification('Success', 'Manufacturer Deleted!', ENotificationType.Primary);
                });
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Manufacturers - onDelete', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }
    }



    return (<>
        {loading === true && <Loading />}
        {things && <div className="col-12">
            <h2>Manufacturers Admin</h2>
            <p className="bg-primary">Bike / Part  OEM manufacturers </p>

            <Helmet>
                <title>Manufacturers / Admin / {auth.metaData && auth.metaData.SYSTEM_NAME && auth.metaData.SYSTEM_NAME}</title>
            </Helmet>

            <Link className="btn btn-success" to="./manufacturers/new">New</Link>
            {/*<!-- OPTIONAL 1 -->*/}




            <DataTable

                colHeadings={[
                    { name: "Name", field: "name", sortable: false },
                    {
                        name: "Bikes", field: "id", r: (value: any, index) => {
                            return <div className="btn-group">
                                {value.bikesObj && value.bikesObj.map((bike: IBike, index: number) => { return <Link className="btn btn-primary" to={`${match.url}/${value.id}`}>{bike.name}</Link> })}

                            </div>;
                        }, sortable: false
                    },
                    {
                        name: "Actions", field: "id", r: (value: any, index) => {
                            return <div className="btn-group">
                                <DebugButton data={value} />
                                <Link className="btn btn-primary" to={`${match.url}/${value.id}`}>Edit</Link>
                                <button className="btn btn-danger" onClick={(ev: React.MouseEvent) => {
                                    ev.preventDefault();
                                    onDelete(value);
                                }}>Delete</button>u
                            </div>;
                        }, sortable: false
                    },

                ]}

                data={things}
            />

            {/*<!-- OPTIONAL END -->*/}
        </div>}
    </>
    );
};
const AdminManufacturers = () => {
    let match = useRouteMatch();
    return (<>
        <Switch>
            <Route path={`${match.path}/:id`}>
                <AdminManufacturer />
            </Route>
            <Route path={`${match.path}`} exact>
                <AdminManufacturersPge />
            </Route>

        </Switch>
    </>
    );
}

export default AdminManufacturers;